
import { User } from '@/model';
import users from '@/store/users';
import { notEmpty } from '@/util/array-util';
import Vue from 'vue';

export default Vue.extend({
  name: 'UserPicker',
  props: {
    value: { type: [Object, Array] as any as () => User | User[] },
    label: { type: String, default: () => 'Pick user' },
    clearable: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
  },

  computed: {
    users(): User[] {
      return users.state.users?.filter(notEmpty) || [];
    },
    multiple(): boolean {
      return Array.isArray(this.value);
    },
  },

  methods: {
    input(value: User[] | User) {
      this.$emit('input', value);
    },
  },
});
